import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { fixDate } from "../../helpers/helperFunctions";

const DeactivatingNew = ({ devices }) => {
	const { t } = useTranslation();
	return (
		<>
			<div className="d-flex flex-column align-items-center">
				<div className={`d-flex flex-column w-100 dataplan-selection`}>
					<p className="bold mb-1">{t("subscription.active_devices")}</p>
					<div className="d-flex flex-column">
						<div className={`settings-radius`}>
							{devices?.map((device, index) => {
								const provider = device?.payment_provider;
								const duration = device?.dataplan?.duration;
								const next_payment = device?.dataplan?.duration_end;

								const durationLabel = (duration) => {
									if (!duration) return;
									switch (Number(duration)) {
										case 1:
											return t("subscription.monthly");
										case 12:
											return t("subscription.yearly");
										default:
											return t("subscription.duration_months", { count: duration });
									}
								};
								return (
									<div key={index} className={`p-3 w-100 d-flex flex-column bg-white ${index < devices?.length - 1 ? "border-settings" : ""}`}>
										<div className="d-flex flex-column">
											<h4 className="mb-1">{device.name}</h4>
											<p className="">
												{t("subscription.id")}: <span className="bold">{device?.imei}</span>
											</p>
											<p className="">
												{t("subscription.data_plan")}:{" "}
												<span className="bold">
													{device?.dataplan?.plan_name} - {durationLabel(duration)}
												</span>
											</p>
											<p className="">
												{t("subscription.payment")}: <span className="bold">{provider === "stripe" ? t("subscription.card") : t("subscription.invoice")}</span>
											</p>
											{next_payment && (
												<p className="">
													{t("subscription.next_payment")}: <span className="bold">{fixDate(next_payment, true)}</span>
												</p>
											)}
										</div>
									</div>
								);
							})}
						</div>
						{devices?.length === 0 && (
							<div className={`p-3 w-100 d-flex flex-column bg-transparent`}>
								<span className="regular">{t("settings.no_devices")}</span>
							</div>
						)}
					</div>
				</div>
			</div>
		</>
	);
};

export default DeactivatingNew;
